import { CustomAnimation } from '../CustomAnimation';
import { AnimationGroup } from '../AnimationGroup';
import { getElement, getElementMotionPart, measure, mutate, getRanges, getNamedEffect, getEffectsData, isNotAScrubTrigger } from './common';
import fastdom from 'fastdom';
function getWebAnimationEffect(preset, animation, target, trigger, options) {
  if (preset) {
    // validate duration is a number over 0
    if (isNotAScrubTrigger(trigger)) {
      animation.duration = animation.duration || 1;
      if (options != null && options.reducedMotion) {
        if (animation.iterations === 1 || animation.iterations == undefined) {
          animation = {
            ...animation,
            duration: 1
          };
        } else {
          return [];
        }
      }
    }
    let domApi;
    if (target instanceof HTMLElement) {
      domApi = {
        measure: measure(target),
        mutate: mutate(target)
      };
    }
    return preset.web ? preset.web(animation, domApi, options) : preset(animation, domApi, options);
  }
  return [];
}
function getWebAnimation(target, animationOptions, trigger, options, ownerDocument) {
  const element = target instanceof HTMLElement ? target : getElement(target, ownerDocument);
  if ((trigger == null ? void 0 : trigger.trigger) === 'pointer-move') {
    let effectOptions = animationOptions;
    if (animationOptions.customEffect) {
      effectOptions = {
        ...animationOptions,
        namedEffect: {
          id: '',
          type: 'CustomMouse'
        }
      };
    }

    // TODO: need to fix the type here, currently lying about the returned type to be WebAnimationEffectFactory instead of MouseAnimationFactoryCreate
    const mouseAnimationPreset = getNamedEffect(effectOptions);
    const mouseAnimationFactory = getWebAnimationEffect(mouseAnimationPreset, animationOptions, element, trigger, options);
    return mouseAnimationFactory(element);
  }

  // get the preset for the given animation options
  const namedEffect = getNamedEffect(animationOptions);
  const animationsData = getWebAnimationEffect(namedEffect, animationOptions, element, trigger, options);
  const data = getEffectsData(animationsData, trigger, animationOptions.effectId);
  let timeline;
  const isViewProgress = (trigger == null ? void 0 : trigger.trigger) === 'view-progress';

  // if this is a ScrubAnimation with view-progress trigger and the browser supports the ViewTimeline API
  if (isViewProgress && window.ViewTimeline) {
    // generate the timeline object
    // @ts-expect-error
    timeline = new ViewTimeline({
      subject: trigger.element || getElement(trigger.componentId)
    });
  }

  // generate an Animation object for each data object
  const animations = data.map(_ref => {
    let {
      effect,
      options: effectOptions,
      id,
      part
    } = _ref;
    const effectTarget = part ? getElementMotionPart(element, part) : element;
    const keyframeEffect = new KeyframeEffect(effectTarget || null, [], effectOptions);

    // set the keyframes for the KeyframeEffect after measurements and mutations
    fastdom.mutate(() => {
      if ('timing' in effect) {
        keyframeEffect.updateTiming(effect.timing);
      }
      keyframeEffect.setKeyframes(effect.keyframes);
    });
    const timingOptions = isViewProgress && timeline ? {
      timeline: timeline
    } : {};
    const animation = typeof effect.customEffect === 'function' ? new CustomAnimation(effect.customEffect, effectTarget || null, effectOptions, timingOptions) : new Animation(keyframeEffect, timingOptions.timeline);

    // if this is a ScrubAnimation with view-progress trigger and the browser supports the ViewTimeline API
    if (isViewProgress) {
      if (timeline) {
        // set the ranges for the animation after measurements and mutations
        fastdom.mutate(() => {
          const {
            start,
            end
          } = getRanges(effect);
          // @ts-expect-error
          animation.rangeStart = start;
          // @ts-expect-error
          animation.rangeEnd = end;
          animation.play();
        });
      } else {
        const {
          startOffset,
          endOffset
        } = animationOptions;

        // set the ranges for the animation after measurements and mutations
        fastdom.mutate(() => {
          var _offset, _offset2;
          const startOffsetToWrite = effect.startOffset || startOffset;
          const endOffsetToWrite = effect.endOffset || endOffset;
          Object.assign(animation, {
            start: {
              name: startOffsetToWrite.name,
              offset: (_offset = startOffsetToWrite.offset) == null ? void 0 : _offset.value,
              add: effect.startOffsetAdd
            },
            end: {
              name: endOffsetToWrite.name,
              offset: (_offset2 = endOffsetToWrite.offset) == null ? void 0 : _offset2.value,
              add: effect.endOffsetAdd
            }
          });
        });
      }
    }
    if (id) {
      animation.id = id;
    }
    return animation;
  });

  // create an AnimationGroup with the generate animations
  return new AnimationGroup(animations, {
    ...animationOptions,
    trigger: {
      ...(trigger || {})
    },
    // make sure the group is ready after all animation targets are measured and mutated
    measured: new Promise(resolve => fastdom.mutate(resolve))
  });
}
export { getWebAnimation };
//# sourceMappingURL=webAnimations.js.map